import { LangData } from "../types";

const lang: LangData = {
  // App.vue
  selectLang: "seleccionar Idioma",
  cancel: "Cancelar",
  clientArea: "Área de clientes",
  seeAllStores: "Todos los comercios",
  addStore: "Añadir comercio",
  login: "Iniciar sesión",
  signUp: "Registrarse",
  contact: "Contacto",
  editData: "Modificar datos",
  logout: "Cerrar sesión",
  store: "Comercio",

  // Auth Login Form
  authTitle1: "ACCESO AL ÁREA DE CLIENTES",
  rememberPassword: "Recordar contraseña",
  requiredEmailAlert: "Por favor, ingresa un correo electrónico.",
  validEmailAlert: "El correo electrónico debe ser válido.",
  passwordLegend: "¿Ha olvidado su contraseña?",
  toAccess: "Acceder",
  activeSessionLegend:
    "Hay una sesión activa en este navegador. Por favor confirme la cuenta con la cual desea acceder al sistema.",
  accessThisAccount: "Acceder con esta cuenta",
  useOtherUser: "Utilizar otro usuario",
  recoverPasswordLegend:
    "Ingrese su correo electrónico y le enviaremos un mensaje con instrucciones que le permitirán recuperar la contraseña.",
  email: "Correo electrónico",
  sendMessage: "Enviar mensaje",
  sendMessageLegend1: "¡Mensaje enviado!",
  sendMessageLegend2: "Siga las instrucciones del mensaje para reiniciar su contraseña.",
  sendMessageLegend3: "Si no recibe el mensaje en unos minutos revise su casilla de SPAM.",
  errorMsgLogin: "No se pudo iniciar sesión",
  errorMsgForm: "Por favor complete los datos del formulario.",
  errorMsgEmail: "No se pudo enviar el correo",
  mfaCodeSentLegend:
    "Le hemos enviado un SMS con un código a su teléfono. Introdúzcalo a continuación para confirmar su número y completar la vinculación de su cuenta.",
  verificationCode: "Código de verificación",
  twoFactorAuth: "Doble factor de autenticación",
  mfaExplanationTitle: "Protege tu cuenta con la verificación en dos pasos",
  mfaExplanationBody:
    "Al añadir su número de teléfono, le enviaremos un código por SMS cada vez que inicie sesión desde un dispositivo nuevo. Es una capa extra de seguridad para garantizar que nadie más pueda acceder a sus datos, aunque conozca su contraseña.",
  mfaEnrolledLegend: "Tiene configurado el siguiente teléfono para verificación en dos pasos:",
  mfaRemove: "Quitar",
  mfaSendCode: "Enviar código",
  mfaCredentialTooOld: "Por seguridad, debe cerrar sesión e iniciarla nuevamente antes de reintentar esta acción.",
  mfaUnverifiedEmail: "Debe verificar su correo electrónico antes de poder configurar la verificación en dos pasos. Complete el código de verificación enviado a su correo (sin saltearlo) para poder continuar.",
  password: "Contraseña",
  preserveLogin: "Mantener la sesión iniciada",
  optionalName: "Nombre de usuario (opcional)",
  welcome: "Bienvenido",

  // AUTH LOGIN
  adminAccessTitle: "Acceso de administración",
  loggingAlert1: "Espere un momento mientras se valida el acceso.",
  loggingAlert2: "La sesión durará solo hasta que cierre el navegador.",
  loggingError: "Se produjo un error al verificar el login:",
  retry: "Reintentar",
  noCommerceId1: "El comercio con ID ",
  noCommerceId2: "no existe actualmente en PAYTEF Web.",
  noCommerceId3: "Para ver las opciones de este comercio presione continuar para y agreguelo al sistema.",
  continue: "Continuar",
  redirectSuccess: "Acceso exitoso. Redirigiendo...",
  noRegister: "¿Aún no estás registrado?",
  singUpHere: "Regístrate aquí.",
  errorMsgRedirect: "Error al intentar continuar",

  // AUTH REGISTER
  registerLegend: "Para efectuar este paso debes tener a mano los datos del comercio provistos por PAYTEF.",
  addCommerce: "Añadir Comercio",
  registerAsAdmin: "Registrarse como Administrador",
  emailValidationErr: "Hubo un problema validando la cuenta. Pruebe de nuevo.",
  emailVAlidationErr2: "Error validando la cuenta, verifique los datos",
  dataErr: "Verifique que los datos sean correctos",
  registerErr: "No se pudo registrar el usuario, verifique que los datos.",
  validatingEmail: "Validando correo electrónico...",
  userExist: "Usuario existente, puede continuar al siguiente paso.",
  newUserDataText: "Nuevo Usuario. Por favor indique los datos a continuación.",
  waitingVilidation: "Esperando comprobación.",
  emailDisponibility: "Escriba un correo para validar su disponibilidad.",
  userName: "Nombre de usuario",
  paytefClientId: "ID del cliente PAYTEF",
  paytefUserName: "Nombre de usuario PAYTEF",
  paytefPassword: "Contraseña de PAYTEF",
  paytefNoDataLegend: "¿No dispone de estos datos? Contacte con nosotros para solicitarlos.",
  registerCommerce: "Registrar Comercio",
  successCommerceLink1: "El comercio ",
  successCommerceLink2: " fue asociado a su cuenta de usuario.",
  commerceData: "Datos del comercio:",
  name: "Nombre",
  city: "Ciudad",
  address1: "Dirección 1",
  address2: "Dirección 2",
  accessSistemLegend: "Acceda al sistema para verlo.",
  registerSuccessRedirect: "Registro finalizado, procesa a la página de acceso para ingresar al sistema.",
  exit: "Salir",
  accessSistem: "Acceder al sistema",
  ruleClientId: "Por favor, ingresa un ID de cliente.",
  ruleNumericClientId: "El ID de cliente debe ser numérico.",
  ruleRequireduserName: "Por favor, ingresa un nombre de usuario.",
  ruleRequiredPassword: "Por favor, ingresa la contraseña.",

  // PASSWORD
  ruleConfirmPasword: "Confirme su contraseña.",
  ruleMinChar1: "La contraseña debe tener ",
  ruleMinChar2: " caracteres o más.",
  rulePasswordReq: "Ingrese la contraseña.",
  ruleConfirmation: "La confirmación debe ser igual a la ",
  repeatThe: "Repita la ",

  // SIDEBAR
  storeMenu: "Comercio",
  transactions: "Transacciones",
  connectionStatus: "Estado de la conexión",
  myStores: "Mis comercios",
  userManagement: "Gestión de usuarios",
  officeconfig: "Configuración de oficinas",
  vending: "Vending",
  tools: "Herramientas",
  paymentRequest: "Solicitudes de pago",
  newRequest: "Nueva solicitud",
  clientAPI: "API de clientes",
  paymentLinkAPI: "API de Payment LINK",
  development: "Desarrollo",
  lastChanges: "Últimos cambios",
  storeMenuHint: "Consulte fácilmente el estado de sus terminales.",
  transactionsHint: "Consulta de transacciones realizadas en su comercio desde terminales PAYTEF.",
  connectionStatusHint: "Consulte fácilmente el estado de la conexión de cualquiera de sus terminales.",
  myStoresHint: "Ver el listado de los comercios asignados a mi usuario.",
  userManagementHint: "Gestionar todos aquellos usuarios a los que desee dar permiso de consulta sobre mis comercios.",
  officeconfigHint: "Gestionar la configuración de las oficinas habilitadas para Payment Link.",
  vendingHint: "Configuración de maquinas de vending.",
  topayHint: "Listado global de los mensajes Topay más antiguos pendientes en todos los terminales.",
  topayNoMessages: "No se encontraron mensajes Topay.",
  paymentRequestHint: "Ver el estado y gestionar las solicitudes de pago enviadas por Payment LINK.",
  newRequestHint: "Crear nueva solicitud de pago y enviarla.",
  clientAPIHint: "Ver la documentación del API de PAYTEF para clientes.",
  paymentLinkAPIHint: "Habilitar acceso a la API de PaymentLink y ver la documentación.",
  paymentLink: "Payment LINK",
  euroshellCertificate: "Certificado Euroshell",
  euroshellCertificateHint: "Crear certificado euroshell y consultar historial",

  //CompanyInfo
  showInactive: "Mostrar Inactivas",
  hideInactive: "Ocutar Inactivas",
  editLogoBtn: "Editar Logos",
  loadingTheStore: "Cargando el comercio...",
  loadingError: "Se produjo un error al cargar el comercio. ",
  message: "Mensaje",
  searchOffice: "Buscar oficina...",
  searchOfficeTcodSn: "Buscar oficina, TCOD o SN...",
  exportToExcel: "Exportar oficinas a Excel",
  selectBranchTerminalInfo: "Selecciona una oficina o terminal para ver sus datos",
  officeID: "ID de la oficina",
  code: "Código",
  tcod: "TCOD",
  activation: "Activación",
  lastConnection: "Última conexión",
  release: "Release",
  devices: "Dispositivos",
  latencyMin: "Latencia (minutos)",
  pcAndIp: "Máquina e IP local",
  lastIP: "Última IP",
  connectionDetails: "Detalles de la conexión",
  queryTransactions: "Consultar transacciones",
  unlockPassword: "Contraseña de desbloqueo",
  ConfigQR: "Código QR de configuración",
  errorCreateQR: "Error creando QR",
  backToMyMerch: "Volver a Mis Comercios",
  backToList: "Volver al listado",
  errorData: "Se produjo un error consultando los datos",
  copyUrl: "Copiar Url",
  urlCopied: "Url Copiada",
  devHardware: "Hardware",
  devDeviceModel: "Modelo",
  devStatus: "Estado",
  devManufacturerCode: "Fabricante",
  devSerialNumber: "S/N",
  devSoftwareVersion: "Software Ver.",
  detail: "Detalle",
  clientID: "Cliente ID",
  province: "Provincia",
  postCode: "Código Postal",
  address: "Dirección",
  commerceCodes: "Codigos de Comercio",

  //TRANSACTIONQUERYV3
  queryOfTransactions: "Consulta de Transacciones",
  filters: "Filtros",
  changeFilters: "Cambiar Filtros",
  exportListToExcel: "Exportar listado a excel",
  showStadistics: "Estadísticas de la Busqueda",
  office: "Oficina",
  loading: "Cargando...",
  selectMerchant: "Seleccione un comercio",
  terminal: "Terminal",
  noTerminals: "No hay terminales",
  dates: "Fechas",
  note: "Nota",
  pdfReportsLegend: "Los reportes PDF solo estan disponibles en rangos menores a 45 días.",
  amount: "Importe",
  lowerLimit: "Limite inferior",
  higherLimit: "Limite superior",
  reference: "Referencia",
  operationReference: "Referencia de la operación",
  transactionID: "ID Transacción",
  operationNumber: "Número de operación",
  cardBinLabel: "BIN de tarjeta",
  cardBinPlaceholder: "Primeros dígitos de la tarjeta",
  cardTypeLabel: "Tipo de tarjeta",
  authCodeLabel: "Código de autorización",
  authCodePlaceholder: "Código de autorización",
  pdfListFormat: "Listado en formato PDF",
  transactionSummary: "Resumen de transacciones",
  statistics: "Estadísticas",
  partialResult: "Resultado cargado parcialmente",
  transactionsPorcDownload1: "Solo se descargo el ",
  transactionsPorcDownload2: "de las transacciones disponibles para el rango de fechas seleccionado.",
  continueDownload: "Continuar descarga",
  loadingText: "Cargando transacciones... Por favor espere un momento.",
  transactionsAlertTitle:
    "Algunas transacciones no pudieron agregarse al total porque tenían errores de formato en el importe",
  totalAmount: "Importe Total",
  loadingTransactions: "Cargando transacciones",
  loadingTransactionsWait1: "Descargando transacciones de",
  loadingTransactionsWait2: "días",
  loadingTransactionsWait3: "Por favor espere un momento...",
  loadingTransactionsWait4: "comercios",
  loadingTransaccionsAlert: "Esta operación puede tardar unos minutos.",
  failed: "Fallida",
  aprove: "Aprobada",
  denied: "Denegada",
  errorIndeterminate:
    "Se produjo un problema indeterminado y la transacción falló. Puede intentar realizarla nuevamente.",
  successfulOperation: "La operación fue completada exitosamente.",
  deniedOperation: "La operación fue denegada por el centro procesador.",
  result: "Resultado",
  transaction: "Transacción",
  card: "Tarjeta",
  seeReceipt: "Ver Recibo",
  finish: "Finalizar",
  ruleValueRequired: "Valor requerido",
  ruleNumericValue: "Valor numérico",
  selectOfficeToFilter: "Seleccione la oficina para filtrar por número de operación",
  errorSelectParams: "Seleccione los parámetros antes de realizar la consulta.",
  errorLoadPage: "Fallo la carga de las páginas",
  errorUnexpected: "Error inesperado cargando las transacciones, pruebe de nuevo",
  errorMissingFilters: "Faltan los filtros",
  errorTryAgain: "Error obteniendo los resultados, vuelva a intentarlo.",
  selectFiltersToDownload: "Seleccione los filtros para descargar el archivo",
  errorCheckFilters: "Revise los filtros",
  successFileGenerated: "Archivo generado",
  errorDownloadingFile: "Error descargando el archivo",
  errorGeneratingFile: "No se pudo generar el archivo",
  errorQueryTransactions: "Error consultando las transacciones",
  noResults: "No hay resultados para descargar, revise los filtros",
  allOffices: "Todas las oficinas",
  company: "Comercio",
  companies: "Comercios",
  date: "Fecha",
  errorPdfFormatNotAvailable: "Formato de descarga no disponible para multiples comercios.",
  withoutCard: "Sin tarjeta",
  totalProgess: "Progreso Total",
  maxDaysLimit: "El periodo máximo de búsqueda debe ser menor o igual a 31 días.",
  byBankAndCard: "Por Banco y Tarjeta - Importe",
  byBankAndCard2: "Por Banco y Tarjeta - Cantidad",
  bank: "Banco",
  filteredTransactionsShowDetails: "Para ver un resumen de las transacciones filtradas, hacer click aqui",
  newTransaction: "Nueva transacción",
  manualClose: "Cierre Manual",
  manualCloseType: "Tipo de Operación",
  closeTerminal: "Cerrar Terminal",
  closeBranch: "Cerrar Oficina",
  filterBy: "Filtrar Por",

  // txnNewDialog
  opType: "Tipo de operación",
  cardNumber: "Numero de tarjeta",
  expirationDate: "Fecha de expiración",
  securityCode: "Codigo de seguridad",
  cfTitleCardData: "Tarjeta de crédito/débito",
  cfTitleExtraData: "Datos de facturación",
  ciCardNameTitle: "Nombre del titular",
  ciCardNumberTitle: "Número de tarjeta",
  ciExpireLabel1: "hasta",
  ciExpireLabel2: "",
  ciExpireTitle: "mes/año",
  ciSecurityCodeTitle: "Cód. Verificación",
  fCardNameLabel: "Nombre del titular",
  fCardNamePlaceholder: "-",
  fCvvLabel: "CVV / CVC",
  fCvvPlaceholder: "XXX",
  fExpireLabel: "MM / AA",
  fExpirePlaceholder: "__/__",
  fPANLabel: "Número de tarjeta",
  fPANPlaceholder: "···· ···· ···· ····",
  errCardInvalid: "Número de tarjeta inválido",
  errCardNameRequired: "Campo obligatorio",
  errCardRequired: "Ingrese el número de tarjeta",
  errExpirationInvalid: "La expiración debe ser MM / AA",
  errExpirationRequired: "Fecha de expiración necesaria",
  errSecurityCodeInvalid: "Código inválido",
  errSecurityCodeRequired: "Número de seguridad necesario",
  authorization: "Autorización",
  test: "Test",
  operationDetails: "Detalle de la Operación",
  cardDetails: "Datos de la Tarjeta",
  authAmount: "Importe a Preautorizar",
  testAmount: "Importe a Testear",
  alertExecuteTransaction: "¡Transacción ejecutada con éxito!",
  errorCouldNotExecuteTransaction: "No se pudo ejecutar la transacción",

  //transactions_query.ts
  dateTime: "Fecha Hora",
  operation: "Operación",
  sale: "Venta",
  refund: "Devolución",
  preauthorization: "Preautorización",
  preauthorizationClose: "Cierre Preautorización",
  preauthorizationCancelation: "Cancelación Preautorización",
  amountTest: "Test de saldo",
  cancellation: "Cancelación",
  tokenization: "Tokenización",
  requestedAmount: "Importe Solicitado",
  finalAmount: "Importe Final",
  authorizationCode: "Cod. Autorización",
  transactionCost: "Coste Transacción",
  state: "Estado",
  dcc: "DCC",
  country: "País",
  resultCode: "Código de Resultado",
  sessionDate: "Fecha de Sesión",
  commerceCode: "Código de Comercio",
  device: "Dispositivo",
  entryMode: "Modo de Entrada",
  titular: "Titular",
  pan: "PAN",
  cardBin: "BIN de la tarjeta",
  cardIssuer: "Emisor y País",
  companyCard: "Tarjeta de empresa",
  creditoOrDebit: "Crédito o Débito",
  server: "Servidor",
  processStatus: "Estado Proceso",
  authorizationCenter: "Centro Autorizador",
  merchantBank: "Banco Merchant",
  t1: "T1",
  t2: "T2",
  id: "ID",
  approvedPlural: "Aprobadas",
  deniedPlural: "Denegadas",
  failedPlural: "Fallidas",
  generalInfo: "Información general",
  cardData: "Datos de tarjeta",
  processing: "Procesamiento",

  // BranchConfig.vue
  officeConfiguration: "Configuración de Oficinas",
  loadingMerchant: "Cargando el comercio...",
  selectMerchantToSeeOffice: "Seleccione un comercio para ver las oficinas",
  errorLoadingOffice: "Se produjo un error cargando las oficinas.",
  merchantNoOffice: "Este comercio no dispone de oficinas para configurar",
  selectOfficeToSeeConfig: "Selecciona una oficina para ver la configuración",
  backendEnv: "Entorno de backend",
  backendEnvHint: "Determina que servidor procesa las transacciones",
  nameToShow: "Nombre a mostrar",
  version3dS: "Versión de 3D Secure",
  version3dSTxt1: "Se recomienda utilizar la version 2.0. Se incluye la versión 1.0 solo por compatibilidad.",
  version3dSTxt2:
    "Consulte con PAYTEF para asegurarse de tener habilitada la version 2.0 antes de modificar esta propiedad.",
  version3dSlbl2: "3D Secure 2.0",
  customStyle: "Personalizar estilo de las páginas",
  officeIdentification: "Identificación de la oficina",
  officeIdentificationText: "Aparecerá en el encabezado del formulario y en la base de los paneles de PUCE.",
  imgSizeLegend: "La imagen debe tener 50 pixeles de alto y como máximo 300 pixeles de ancho.",
  customCssFile: "Archivo CSS personalizado",
  optionalStyleText: "Hoja de estilos opcional para personalizar aún más el estilo de las páginas.",
  uploadCss: "Subir CSS",
  restpreOriginal: "Restaurar original",
  paymentLinkLowercase: "Payment Link",
  paymentWebData: "Datos para la página de cobro",
  image: "Imagen",
  requiredLogoConfig: "Es necesario configurar un logo",
  change: "Cambiar",
  contactEmail: "E-mail de contacto",
  contactPhone: "Teléfono de contacto",
  senderName: "Nombre del remitente",
  senderNameHint: "Este valor aparecerá en la firma de los e-mails al cliente",
  resultEmail: "E-mail de resultados",
  resultEmailHint: "Recibirá una notificación en el e-mail indicado cuando el cliente pague",
  errorEnableOffice:
    "No se pudo habilitar la oficina porque falta la clave de firma HMAC. Contacte con soporte para configurarla.",
  errorIncorrectForm: "Se encontraron errores en el formulario, por favor reviselos e intente de nuevo.",
  previewInPuce: "Vista previa en PUCE",
  save: "Guardar",
  configuredOffices: "Oficinas configuradas",
  available: "Disponibles",
  branchName: "Nombre de la oficina",
  pickImg: "Elija una imagen...",
  circle: "Círculo",
  square: "Cuadrado",
  squareRounded: "Cuadrado redondeado",
  emailNotification: "Notificar vencimiento al E-mail",

  // ConnectionStatus.vue
  selectTerminalToSeeConnectionData: "Seleccione una oficina para ver sus datos.",
  noDataFound1: "No se encontraron registros para",
  noDataFound2: "en la fecha",
  noDataFound3: "Pruebe otros filtros",
  selectFiltersToSeeTable: "Seleccione los filtros para ver la tabla.",
  openFilters: "Abrir filtros",
  hour: "Hora",
  latency: "Latencia",
  conectionState: "Estado conexión",
  connectionStates: "Estados de conexión",
  selectParametersToFilter: "Seleccione los parámetros antes de filtrar",
  errorFilteringResults: "Error filtrando los resultados",

  // CompanyCatalog.VUE
  welcomeTitle: "Bienvenido al Área de Clientes PAYTEF",
  welcomLegend1: "Desde aquí puede administrar los distintos comercios que tiene asociados a su cuenta.",
  welcomLegend2: "Seleccione a continuación el comercio con el cual desea operar.",
  searchMerchant: "Buscar comercio...",
  userAdministration: "Gestión de Usuarios",
  addMerchant: "Añadir Comercio",
  loadingMerchants: "Cargando los comercios...",
  errorLoadingMerchant: "Se produjo un error cargando las comercios.",
  myMerchants: "Mis comercios",
  add: "Añadir",
  deleteMerchantAlert: "¿Esta seguro que desea borrar este comercio de su perfil?",
  failedToSaveUser: "No se pudo guardar el usuario",
  filteredOffices: "Oficinas filtradas",
  offices: "Oficinas",
  searchByBranch: "Buscar por sucursal o ID de cliente o TCOD",
  searchByBranchHint: "Nota: Las búsquedas por TCOD solo encuentran oficinas, no terminales",
  showMore: "Mostrar más...",
  showMoreMessage: "Mostrando %1 de %2 compañías",

  // HOME.VUE
  welcomeTitleACP: "Bienvenido al área de clientes de PAYTEF (ACP)",
  welcomLegendACP1: "Desde aquí podrá gestionar en tiempo real todos sus terminales de pago PAYTEF.",
  dontHaveUser: "¿Aún no tienes usuario?",
  homeText1:
    "Si eres el administrador de tu comercio puedes registrar el usuario de administración con las credenciales asignadas.",
  homeText2: "Si no dispones de las mismas puedes ponerte en contacto con nosotros para solicitarlas.",
  homeText3: "En caso de no ser administrador, deberás solicitarle tus credenciales al administrador de tu comercio.",
  registerAsAdministrator: "Registrarme como Administrador",
  requireCredentials: "Solicitar mis credenciales",
  whatIsPaytef: "¿Qué es PAYTEF?",
  paytefDescription:
    "PAYTEF es una pasarela de pago que permite la interconexión de un sencillo interface con la aplicación de gestión del TPV.",
  knowMore: "Conocer más",
  whatIsAcp: "¿Qué es ACP?",
  acpDescription:
    "ÁREA DE CLIENTES PAYTEF (ACP) es un área que permite a los usuarios de PAYTEF gestionar integramente sus terminales de pago. Por ejemplo, podrá consultar desde cualquier lugar y en tiempo real todas las transacciones bancarias realizadas a través de cualquiera de sus terminales de forma fácil y segura.",
  howToUseAcp: "¿Cómo se usa ACP?",
  howToUseAcpText:
    "Basta con que nos solicite sus datos de acceso y con ellos curse su alta en el sistema como Administrador de su comercio. Una vez cursada, tendrá acceso a distintas funcionalidades tales como consultar las transacciones de todos los terminales de su comercio, o como gestionar sus usuarios y las oficinas a las que tendrán acceso.",

  // UserManager.vue
  usersAdministration: "Administración de Usuarios",
  search: "Consultar",
  refresh: "Refrescar",
  access: "Accesos",
  import: "Importar",
  notAssigned: "No asignado",
  merchantWithoutUsers: "Este comercio no tiene usuarios.",
  theSearchNoResults1: "La busqueda de",
  theSearchNoResults2: "no produjo resultados.",
  couldNotAccessUserList: "No se pudo obtener la lista de usuarios",
  selectMErchantDialog: "Seleccione un comercio",
  removingAccessAlert1: "Esta quitando el acceso de",
  removingAccessAlert2: "al comercio",
  removingAccessAlert3: "¿Desea continuar?",
  deletedUserRefresh: "Usuario borrado, refrescando lista.",
  couldNotRemoveUser: "No se pudo borrar el usuario",
  successfulAction: "Acción exitosa, refrescando lista.",
  failedAction: "No se pudo realizar la acción",
  merchant: "Comercio",
  email2: "Email",
  permissions: "Permisos",
  lastAccess: "Último acceso",
  terminalsStatus: "Estado de Terminales",
  seeTransactions: "Ver transacciones",
  basicRole: "Rol básico",
  all2: "Todas",
  administrator: "Administrador",
  searchOfficeByNameID: "Buscar oficina por Nombre o ID...",

  // ClientAPI.vue
  paytefClientApi: "API de PAYTEF para clientes",
  generalOpAuthTitle: "Operativa general y autenticación",
  wayToMakeCall: "Todas las llamadas al API PAYTEF se realizarán de la siguiente manera:",
  desiredFunction: "{funciondeseada}",
  optionalParamsText:
    "Opcionalmente, se podrá añadir el parámetro ?env=preprod si asi se lo indica soporte, para acceder a alguna funcionalidad que aun esté en el entorno de preproducción, pero esto tan solo será bajo  indicación de soporte.",
  authFirstData: "La autenticación será el primer bloque de datos a enviar, seguida por los parámetros; por ejemplo:",
  reqDistinctParams: "Los distintos parámetros de la petición",
  authParams: "Esta autenticación (authentication) incluirá:",
  merchantId: "El ID de empresa",
  assignedUserName: "El nombre de usuario asignado",
  assignedPassword: "El password asignado",
  dataProvidedBySuport: "Todos estos datos serán facilitados por el soporte PAYTEF al generar una nueva empresa.",
  resErrorHandleTitle: "Manejo de respuestas y errores",
  resFortySecText1:
    "Toda petición debe esperar un mínimo de 40 segundos a obtener una respuesta (sobretodo en casos como la consulta de transacciones donde el volumen a devolver puede ser grande).",
  resFortySecText2: "Las respuestas vendrán como ",
  resSuccessful: "En caso de respuesta exitosa, devolverán un código 200 – OK, y el cuerpo del mensaje en JSON:",
  forExample: "Por ejemplo",
  errorHandle: "Manejo de errores:",
  resError400: "Errores en la petición (p.ej: Password incorrecto): Código 400 – Bad Request y",
  resError500: "Errores de sistema: Código 500 – Server Error; sin más datos normalmente",
  docCompability:
    "La documentación de la API no es compatible con Internet Explorer 11, por favor actualice su navegador.",

  //Changelog.vue y changeLog.ts
  siteRecentChanges: "Cambios recientes del sitio",
  generalChanges2: "Cambios generales",
  generalChangesItem1: "Las oficinas ahora muestran los IDs del cliente si están disponibles",
  generalChangesItem2: "El tamaño del QR de configuración es más grande para que el dispositivo lo reconozca mejor",
  generalChangesItem3: "Se elimino el borde de los QRs de configuración para que lo reconozca mas facilmente",
  generalChangesItem4:
    'Transacciones: Las fechas se corrigen solas en el filtro cuando se selecciona una fecha "desde" posterior a la fecha "hasta" o una fecha "hasta" anterior a la fecha "desde"',
  generalChangesItem5: "Puesta a punto y actualización de todas las dependencias para corregir vulnerabilidades y bugs",
  generalChangesItem6: "Mejoras generales al estilo visual del sitio",
  generalChangesItem7: "Nueva página de Changelog",
  generalChangesItem8: "Nuevo estilo para la documentación de las APIs y varias correcciones de bugs",
  generalChangesItem9:
    "Nueva 'contraseña de desbloqueo' visible en la sección 'Comercio', solo para administradores. Permite desbloquear termporalmente el modo kiosko en los dispositivos.",
  generalChangesItem10:
    "Las transacciones de 'test de saldo' ahora permiten realizar ventas sobre la tarjeta testeada.",
  generalChangesItem11: "Corrección de un bug que no permitía modificar los logos en 'Configuración de Oficinas'",
  generalChangesItem12: "Se actualizó el año de copyright",
  generalChangesItem13: "Los menues de APIs se movieron a la sección desarrollo",
  vending2: "Vending",
  vendingItem1: "Nueva página de vending para configurar los terminales",
  vendingItem2: "Mejoras a la página de configuración de vending",
  vendingItem3: "Nuevo rol de usuario que permite modificar vending sin ser administrador",
  vendingItem4:
    "El menú de Vending se movió debajo de 'Configuración de oficinas' y aparece siempre si el usuario tiene el permiso asignado",
  connectionStatus2: "Estado de conexión",
  connectionStatusItem1: "Al modificar el comercio, o la oficina se limpia el listado",
  connectionStatusItem2:
    "BUGFIX: La descarga del PDF y el excel ahora reflejan la fecha correcta de la ultima consulta realizada",
  transactions2: "Transacciones",
  transactionList2: "Listado de transacciones",
  transactionListItem1: "Nuevo filtro por importe",
  transactionListItem2: "Al modificar el comercio se limpian los filtros y el listado",
  transactionListItem3: "El combobox de oficinas ahora permite realizar búsquedas",
  transactionListItem4: "Nuevos filtros dinámicos por cada columna que filtra las filas en el momento",
  transactionListItem5: 'Nuevo filtro en la consulta por "Terminal"',
  transactionListItem6: "Versión para móvil de la lista que muestra los detalles de forma vertical",
  transactionListItem7:
    "La página inicial ahora es la lista de Transacciones. Si el usuario tiene 1 comercio será seleccionado automáticamente.",
  transactionListItem8: "Pequeñas correcciones a la terminología del dialogo para editar preautorizaciones",
  transactionListItem9:
    'Las transacciones de "Cancelación de Preautorización" ahora permiten realizar la acción "Nuevo cobro"',
  transactionListItem10: "Nueva descarga de recibo en formato 'Imagen'",
  transactionListItem11: "Correcciones de margenes y tamaños de letra para los recibos en formato PDF",
  officeConfig2: "Configuración de oficinas",
  officeConfigItem1: "Las oficinas aparecen listadas en orden alfabético",
  officeConfigItem2: "Nuevo cuadro de texto para buscar oficinas por el nombre",
  paymentLink2: "Payment LINK",
  paymentLinkItem1: "BUGFIX: Se producía un error al cancelar la subida de archivos adjuntos",
  paymentLinkItem2:
    "BUGFIX: El logo se mostraba cortado si era muy alto y angosto, ahora se achica al tamaño apropiado",
  paymentLinkItem3:
    "Ahora se indica y se controla en el cliente el tamaño máximo de los archivos adjuntos antes de subirlo",
  paymentLinkItem4:
    "El ID de la solicitud se muestra en el listado debajo del link y se puede filtrar el listado por ID",
  paymentLinkItem5:
    'Nuevo botón "Ir a solicitud" que permite ingresar el ID y abrir la ventana de edición directamente',
  paymentLinkItem6:
    "Las solicitudes de prueba ahora tiene una marca en el listado para diferenciarlas mas sencillamente.",
  paymentLinkItem7:
    "Ahora es posible seleccionar 3D Secure 2.0 para las solicitudes de pago. La opción debe ser habilitada en 'Configuración de Oficinas'.",
  paymentLinkItem8: "Algunos cambios menores de estilos a la página de pago",
  paymentLinkItem9: "Corrección de estilos a la visualización de emails",
  usersAdmin2: "Gestión de Usuarios",
  usersAdminItem1: "Nueva utilidad para crear usuarios de forma masiva utilizando una planilla",
  users2: "Usuarios",
  usersItem1: "La restricción de acceso por oficina ahora permite seleccionar más de una.",
  changelogDec1: "La página de inicio del usuario ahora se selecciona dependiendo del rol",
  changelogDec2: "Actualizaciones a la página de vending",
  changelogFeb1: "Nueva ventana de selección de logos para la pantalla principal del PIN/PADs y del recibo.",
  changelogFeb2: "Actualizaciones a las definiciones de las APIs",
  changelogFeb3: "BUGFIX: Los mensaje de error no se veían en las páginas muy largas",
  changelogFeb4: "Nuevo botón para enviar emails directo desde el listado de solicitudes",
  changelogFeb5: "La selección de idioma del usuario es persistente",
  changelogFeb6: "BUGFIX: Los emails para idiomas no definidos utilizan inglés por defecto",
  changelogFeb7: "Nueva funcionalidad que permite indicar horas para la expiración de una solicitud",
  changelogFeb8: "Nuevos idiomas incorporados a la web y nuevo soporte multilenguaje para los emails",
  changelogJun1: "Nueva tarjeta animada",
  changelogJun2: "Mejoras a los estilos de la página y mejor soporte para móviles",
  changelogJun3: "Mejoras al backend y correcciones de seguridad",
  changelogJun4: "Soporte para transacciones de tokenización",
  changelogAug1: "Soporte multilenguaje para el sitio, nuevo idioma Inglés",
  changelogAug2: "Transacciones.	Nueva funcionalidad para consultar las transacciones de todas las compañías.",
  changelogAug3: "BUGFIX: soporte para reintentar consultar transacciones",
  changelogAug4: "Mejora en la imágenes y detalle de topay",
  changelogAug5: "Incorporación de Selección Host.",
  changelogSep1: "Consulta transacciones se incorporo link a la transacción anterior",
  changelogSep2: "Se limito a 31 dias las consultas de transacciones",
  changelogSep3: "Incorporación Tokenización",
  changelogSep4: "Incorporación información DCC",
  changelogNov1: "Transacciones.	Incorporación de seccion estadisticas",
  changelogNov2: "Incorporación urls de notificación de vencimiento al cliente",
  changelogNov3: "Incorporación 'Créditos visibles' a Topay",
  changelogNov4: "Creación pantalla Administración y visualización token.",
  changelogNov5: "Incorporación marca cuando es edición",
  changelogNov6: "Reconocimiento idioma del navegador",
  changelogNov7: "Incorporación de notificación al vencimiento",
  changelogDec3: "Incorporación modo de operación 'Recargador'",
  changelogDec4: "Incorporación parámetro 'Lectura toPay'",
  changelogEne1: "Incorporación del idioma en la configuración",
  changelogEne2: "Mejora validación token",
  changelogEne3: "Transacciones. Suporte de las devoluciones bizum",
  changelogFeb9: "Incorporación certificados euroshell",
  changelogFeb10: "Modificación parámetros modo pulso",
  changelogFeb11: "Mis comercios. Incorporación de búsqueda de comercio por código de oficina",
  changelogFeb12: "Mejora de las estadísticas de transacciones",
  changelogFeb13: "Incorporación operación datafono.",
  changelogAbr1: "Incorporación cobro con operación anterior al vencimiento",
  changelogMay1: "Transacciones.	Nuevo filtro de hora por procesamiento o local",
  changelogMay2: "Comercio. Incorporación botón para copiar url de QR",
  changelogMay3: "Soporte de la operatoria Bizum",
  changelogMay4: "PUCE. Eliminación operatoria  3D Secure 1.0",
  changelogMay5: "Transacciones	Incorporación Venta (forzada) y Devolución (Forzada)",
  changelogMay6: "Mejora pantalla configuración y previsualización",
  changelogJun5: "Transacciones	Mejora exportar Excel (incorporación columna 'Operación Anterior')",
  changelogJun6: "Soporte de estadísticas de dispositivos",
  changelogJun7: "Administrador: carga terminales debug de apps.",
  changelogOct1:
    "Incorporación funcionalidades: ejecución de comandos, copiar configuración y borrado masivo de mensajes topay mensajes",
  changelogNov8: "Notificación del estado sistema Redsys",
  changelogNov9: "Incorporación funcionalidad 'Nuevo Cobro' en preautorizaciones",
  changelogEne4: "Actualización documentación Device API",
  changelogMar1: "Nueva funcionalidad para la devoluciones de Ventas Forzadas",
  changelogMar2: "Mejora de la configuración de Vending",
  changelogAbr2: "Nueva funcionalidad para incorporar CSS a PUCE",
  changelogMay7: "Actualización documentación Device API",
  changelogJun8: "Mejora de la configuración de Vending",
  changelogAug6: "Preautorización: nuevo link a la operación de cancelación/cierre",

  // Contact.vue
  contactText: "Póngase en contacto con nosotros para solicitar sus datos de acceso o reportar problemas.",
  tecnicalSuport24: "Soporte Técnico 24 h",
  phone: "Teléfono",
  centralita: "Centralita",

  // UserSettings.vue
  userData: "Datos de cuenta",
  saveData: "Guardar datos",
  changeThePassword: "Contraseña",
  currentPassword: "Contraseña actual",
  newPassword: "Nueva contraseña",
  changePassword: "Cambiar contraseña",
  ruleRequiredEmail: "Por favor, ingrese un correo electrónico.",
  ruleInvalidEmail: "El correo electrónico debe ser válido.",
  profileUpdated: "Se actualizo el perfil de usuario",
  errorChangePassword: "¡Hubo un problema cambiando la contraseña!",
  successfulChangePassword: "Contraseña cambiada con exito",
  passwordTitle: "La contraseña debe contener:",
  passLowercase: "- Al menos una letra.",
  passUppercase: "- Al menos una letra mayúscula.",
  passNumber: "- Al menos un número.",
  passEspecialChar: "- Al menos un carácter especial.",
  passLenght: "- Al menos 8 caracteres.",
  usersExportFilename: "Listado usuarios PAYTEF",
  export: "Exportar",

  // VendingConfig.vue
  vendingConfig: "Configuración de Vending",
  noAvailableLogo: "Logotipo no disponible",
  edit: "Modificar",
  preview: "Previsualizar",
  terminals: "Terminales",
  selectTerminalToSeeConfig: "Selecciona un terminal para ver la configuración",
  loadingData: "Cargando datos...",
  baseCurrency: "Moneda Base",
  toPayConfig: "Configuración: ToPay",
  toPayMessageDeleted: "Mensaje de topay borrado con exito",
  site: "Sitio",
  machine: "Maquina",
  firm: "Firma",
  operationMode: "Modo de operacion",
  slaveMDB: "Configuración: MDB Esclavo",
  chargerTitle: "Configuración: Recargador",

  firstLine: "Primera Linea",
  preauthInitialAmount: "Importe Preautorización Inicial",
  cashless: "Cashless",
  vendVendingTimeout: "Timeout de dispensación",
  vendVendingTimeoutHint:
    "Tiempo de espera máximo para la dispensación del producto (desde VEND APPROVED a VEND SUCCESS)",
  vendSessionTimeout: "Timeout de sesión",
  vendSessionTimeoutHint: "Tiempo máximo permitido para la sesión antes de pagar",
  vendPaymentTimeout: "Timeout validación pago",
  vendPaymentTimeoutHint: "Tiempo máximo permitido para validar el pago desde el inicio del proceso",
  machineAmount: "Precios en Maquina",
  priceTable: "Tabla de precios",
  priceTableWarning1: "La tabla de precios esta vacía, no funcionará el pago con tarjeta.",
  priceTableWarning2:
    "La tabla de precios está vacía por lo que la carga de precios limpiará los precios en máquina. Hasta que no se carguen los precios no funcionará ni el pago con tarjeta ni el pago con efectivo.",
  priceTableAsk: "¿Desea guardar de todas formas?",
  alwaysAmount: "Siempre Saldo",
  cashSaleIncludesBaseCoin: "CashSale C/M.Base",
  alwaysIdle: "Always Idle",
  preauthInitial: "Preautorización Inicial",
  loadCredit: "Carga de crédito",
  readerEnabledByDefault: "Lector habilitado al iniciar",
  directSale: "Venta directa",
  linesGroup: " Agrupación de Líneas",
  validationDelay: "Retraso de Validación",
  pulseConfig: "Configuración: Pulso",
  pulseDuration: "Duración del Pulso",
  pulseInterval: "Intervalo entre pulsos",
  pulseValue: "Valor del pulso",
  pulseCount: "Cant. pulsos",
  productSelectionPolicy: "Selección de producto",
  line: "Línea",
  pCash: "P.Efectivo",
  pCard: "P.Tarjeta",
  cash: "Efectivo",
  addLine: "Añadir Línea",
  topayMessagesLoadMore: "Cargar mas...",
  Preview2: "Previsualización",
  confirmCorrectImage: "Confirme que la imagen sea correcta antes de confirmar.",
  updateImage: "Actualizar Imagen",
  errorLoadingLogo: "Error cargando logo",
  errorLoadingTerminal: "Error cargando terminal",
  successfulSave: "Guardado exitosamente",
  errorSaving: "Error guardando: ",
  errorInvalidFields: "Campos inválidos, revise el formulario",
  ruleRequiredValue: "Valor obligatorio",
  ruleValueMin0: "El valor debe ser mayor o igual a 0",
  ruleValueMAx500: "El valor maximo es 500",
  errorLoadingImage: "Problema cargando la imagen",
  updatedImage: "Imagen actualizada",
  errorUloadingImage: "Problema subiendo la imagen",
  showQR: "Mostrar QR",
  messages: "Mensajes",
  topayQueuedMessages: "Mensajes encolados de Topay",
  balancePresentation: "Presentación Saldos",
  topayReading: "Lectura",
  Language: "Lenguaje",
  toPayAutoSale: "Venta Automática ToPay",
  enabledByInputSignal: "Habilitar UI con señal de entrada",
  enabledByInputSignalHint:
    "Si esta habilitado, la aplicación verifica la señal de entrada seleccionada, si la señal es 1 los botones aparecen habilitados, si es 0 se deshabilitan los botones en pantalla",
  noResultsVending: "NO SE ENCOTRARON RESULTADOS",
  loadingStatistics: "CARGANDO ESTADÍSTICAS",
  configuration: "Configuración",

  topay: "ToPay",
  enabled: "Habilitado",
  disabled: "Deshabilitado",
  header: "Encabezado",
  footer: "Pie",
  productDesc: "Desc. Producto",
  changeLangTxt: "¿Está seguro que desea modificar el idioma?",
  changeLang: "Modificar Idioma",
  vendingStatisticsSearch: "Solo se puede buscar hasta 7 días.",
  noAditionalInformation: "NO HAY INFORMACIÓN ADICIONAL",
  executeCommand: "Ejecutar Comando",
  confirm: "Confirmar",
  command: "Comando",
  actions: "Acciones",
  topayMessages: "Mensajes Topay",
  executeCommandSuccess: "Comando ejecutado.",
  executeCommandFailed: "No se pudo ejecutar el comando.",
  saleRefund: "Venta / Devolución",
  saleRefundHint: "Utiliza la operatoria de VENTA en lugar de PREAUTORIZACIÓN",
  noProductsTxt: "El listado de precios está vacío, indique precios",
  minValueHint: "El tiempo indicado puede resultar insuficiente.",
  importConfig: "Importar Configuración",
  importTerminalConfig: "Importar Configuración",
  clear: "Limpiar",
  copy: "Copiar",
  ConfigFound: "Configuración encontrada con exito. Al aceptar se podrá revisar la misma antes de guardarla.",
  ConfigNotFound: "Configuración no encontrada.",
  selectBranch: "Seleccionar Oficina",
  selectTerminal: "Seleccionar Terminal",
  cardPayment: "Pago con tarjeta",
  saleMode: "Modo de Venta",
  defaultAmount: "Saldo por defecto",
  readerEnabledStart: "Deshabilitar este checkbox si la maquina tiene Control de Menores",
  cashSale: "Venta efectivo moneda base",
  cashSaleHint:
    "Si se activa, se multiplica el valor recibido de MDB por la moneda base y se envía la notificación de venta efectivo a Topay con este nuevo valor (la máquina cumple protocolo).\nSi se desactiva, la notificación se envía a Topay directamente con el valor recibido de MDB (no cumple protocolo: máquinas que envían el valor real de la venta).\nPor ejemplo: si el valor recibido de la máquina es 3 y la moneda base es 5, con checkbox activado se reporta 15 a Topay y con checkbox desactivado se reporta 3.",
  alwaysAmountHint:
    "Asigna 1 céntimo de crédito cuando la tarjeta Topay no tiene saldo, para evitar el problema en máquinas que no permiten ventas con saldo 0",
  minCharge: "Recarga mínima",
  allowOtherCharge: "Habilitar recarga por otro importe",
  topayTicketQr: "Habilitar recibo de Topay",
  predefinedCharge: "Recargas predefinidas",
  predefinedChargeHint: "Permitido hasta 4 valores maximo.",
  saveStatistics: "Guardar estadísticas",
  forcePrices: "Forzar Precios",
  forceConfig: "Forzar Configuración",
  askForcePrices: "¿Está seguro que desea forzar precios?",
  askForceConfig: "¿Está seguro que desea forzar configuración?",
  forceFailed: "No se pudo forzar ",
  forceSuccess: "Operación ejecutada con exito.",
  price: "Precio",
  topayOptions: "Opciones ToPay",
  qrCameraType: "Camara QR",
  qrFlashOn: "Encender flash al escanear QR",
  vendingTicket: "Ticket de venta",
  vendingPrintEnabled: "Habilitado",
  vendingPrintDisabled: "Deshabilitado",
  vendingVirtualTicket: "Ticket Virtual",
  vendingVirtualTicketEnable: "Mostrar ticket por pantalla",
  vendingPrintWithoutPrompt: "Imprimir sin pedir confirmación",
  vendingPaperTicket: "Ticket Papel",
  vendingPaperTicketEnable: "Imprimir ticket papel",
  vendingPaperWidth: "Ancho del papel",
  vendingPrinterType: "Tipo de impresora",

  //AuthRegister.vue
  alreadyGotAccount: "¿Ya tienes una cuenta?",

  //Error.vue
  error: "Error",
  noAccessToPage: "No tienes acceso para acceder a esta página.",
  unexpectedError: "Se produjo un error inesperado",

  //PaymentEdit.vue
  newPaymentRequest: "Nueva solicitud de pago",
  editPaymentRequest: "Editar solicitud de pago",
  copyResquest: "Copiar solicitud",
  cancelRequest: "Cancelar solicitud",
  finishAndbackToList: "Finalizar y volver al listado",
  unabledOffice1: "La oficina de esta solicitud esta deshabilitada o no existe. Ingresa a",
  unabledOffice2: "configuración de oficinas",
  unabledOffice3: "para habilitarla.",
  publish: "Publicar",
  finishRequestLegend:
    "Al finalizar la solicitud ya no podrás editarla y será visible a los usuarios finales que posean el enlace de pago.",
  publishedRequest: "¡Solicitud publicada!",
  canSendTeRequestTo:
    "Ya puedes enviarle la solicitud al cliente. Presiona abajo para que nosotros le mandemos un e-mail o envíale el enlace de pago por tu cuenta.",
  sendPaymentEmail: "Enviar e-mail de pago",
  previewEmail: "Previsualizar e-mail",
  paymentLinkText:
    "Puedes enviarle este enlace a la persona que quieres que realice el pago para que ingrese a la solicitud.",
  paymentLinkUrlHint: "Presiona CTRL+C (en PC) o CMD+C (en MAC) para copiar el contenido",
  customForm: "Formulario personalizado",
  preview2: "Vista previa",
  openAnotherWindow: "Abrir otra pestaña",
  alertPublisRequet: "¡Solicitud publicada!",
  alertCancelRequet: "Solicitud cancelada.",
  alertSuccessEmail: "Correo enviado exitosamente.",
  errorCouldNotGeneratePreview: "No se pudo generar la previsualización",
  erroCouldNotUpdateRequet: "No se pudo actualizar la solicitud",
  alertFinish: "¡Solicitud finalizada!",
  alertExpired: "¡Solicitud expirada!",
  alertCanceled: "¡Solicitud cancelada!",
  alertAproved: "¡Solicitud aprobada!",
  linkCopied: "¡Enlace copiado!",
  pressControlC: "Presiona CTRL+C (en PC) o CMD+C (en MAC) para copiar.",
  wantToPublish: "¿Esta seguro que desea publicar la solicitud?\nUna vez publicada no se podrá volver a editar.",
  wantToCancel: "¿Esta seguro que desea cancelar la solicitud?",
  couldNotLoadRequest: "No se pudo cargar la solicitud de pago",

  //PaymentLinkAPI.vue
  paymentLinkApiTitle: "API de PaymentLINK",
  enableApi: "Habilitar API",
  eneableApiText: "Para acceder al API hay que habilitarlo y generar un token de acceso.",
  accessToken: "Token de acceso",
  accessTokenHint: "Presiona CTRL+C (en PC) o CMD+C (en MAC) para copiar el contenido",
  generateNewToken: "Generar nuevo token",
  generateNewTokenText1: "El token de acceso se agrega en el header HTTP",
  generateNewTokenText2: "Authorization",
  generateNewTokenText3: "con el siguiente formato. El contenido debe comenzar con",
  generateNewTokenText4: "PAYTEF-TOKEN",
  generateNewTokenText5: "y luego el token.",
  generateNewTokenExample1: "A continuación se puede ver un ejemplo:",
  generateNewTokenExample2:
    "Es importante no exponer el token a usuarios finales. Debe usarse solo en comunicaciones de servidor a servidor.",
  errorLoadingConfig: "Error cargando la configuración",
  errorSavingConfig: "Error guardando la configuración",
  generateNewTokenConfirmation: "Generar un nuevo token deshabilitará el token anterior. ¿Deseas continuar?",

  //PaymentList.vue
  goToReq: "Ir a solicitud",
  test2: "test",
  ID: "ID",
  sendConfirEmail: "Enviar email de solicitud",
  selectMerchantToSeeRequest: "Seleccione un comercio para ver las solicitudes.",
  applyFilters: "Aplique los filtros para consultar las solicitudes.",
  requestsNotFound1: "No se encontraron solicitudes de pago para",
  requestsNotFound2: "entre",
  requestsNotFound3: "y",
  requestsNotFound4: "Pruebe otros filtros.",
  selectFiltersToSeeReq: "Seleccione los filtros para ver las solicitudes.",
  loadMore: "Cargar más...",
  close: "Cerrar",
  from: "Desde",
  to: "Hasta",
  requestStatus: "Estado de la solicitud",
  goToRequest: "Ir a solicitud",
  navigateToRequest:
    'Puede navegar directo a la solicitud deseada indicando el ID a continuación y presionando el botón "Navegar":',
  requestIdEx: "ID Solicitud (Ejemplo: gmdHJX7lyPe9SE...)",
  navigateToRequestBtn: "Navegar a solicitud",
  sendConfirmationEmail: "Enviar email de confirmación",
  creation: "Creación",
  expiration: "Expiración",
  visible: "Visible",
  errorSelectParamsToQuery: "Seleccione los parámetros antes de realizar la consulta.",
  errorFilteringResultsRetry: "Se produjo un error filtrando los resultados, por favor vuelva a intentarlo.",
  all: "Todos",
  pending: "Pendiente",
  cancelled: "Cancelada",
  expired: "Expirada",
  filenameName1: "Solicitudes de pago",
  filenameName2: "del",
  filenameName3: "al",
  paymentRequet: "Solicitudes de pago",
  errorSendingEmail: "Error enviando email",
  onExpireCharge: "Operación Procesada al Vencimiento = ",

  // TerminalQRConfig.vue
  terminalConfig: "Configuración de terminal",
  terminalConfigText: "Esta página contiene los datos necesarios para configurar su terminal.",
  generatingQR: "Generando código QR",
  errorGeneratingQR: "Error creando QR, intente recargar la página o contacte con PAYTEF",
  errorExtractingDataQR:
    "No se pudieron extraer los datos del QR, puede ser que no corresponda a un QR válido. Si su dispositivo no procesa la imagen pongase en contacto con PAYTEF.",

  // Test.vue
  importData: "Importar datos",
  importUsers: "Importar usuarios",
  importMerchants: "Importar empresas",
  importData2: "Import Data",
  uploadFile: "Subir archivo",
  pressImportToStart: "Presiona importar para comenzar.",
  usersLoading: "Usuarios...",
  merchantsLoading: "Empresas...",
  merchantsInvoking: "Empresas: Invocando servicio...",
  merchantsWaiting1: "Empresas: Importadas. Esperando ",
  merchantsWaiting2: " segs para la próxima.",
  finished: "Terminado.",

  // DATATABLES
  rowsPerPage: "Filas por páginas:",
  noResultsAvailable: "No hay datos disponibles",
  datatableLoading: "Cargando...",

  // PaymentForm.vue
  paymentData: "Datos del pago",
  selectCompany: "Seleccione un comercio",
  branch: "Oficina",
  referenceNumber: "Número de referencia (Reserva, factura, etc.)",
  currency: "Moneda",
  createPaymentToken: "Crear token de tarjeta (Tokenización)",
  testRequest: "¿Es solicitud de prueba?",
  payerMessage: "Mensaje para el cliente",
  timeLimitToPay: "Tiempo límite para el pago",
  timeZone: "Zona Horaria",
  dateLimit: "Fecha límite",
  validHours: "Horas de validez",
  paymentDateLimit: "Fecha límite de pago",
  paymentDateLimitText:
    "El tiempo de validez de la solicitud incluye la fecha seleccionada. El pago expirará a las 23:59 del día seleccionado en el timezone seleccionado.",
  hoursQuantity: "Cantidad de horas",
  hoursQuantityText: "Las horas se cuentan desde el momento de creación de la solicitud de pago",
  radioCustomerAuthentication: "Autenticación de cliente",
  radioCustomerAuthenticationWeak: "Weak (No seguro)",
  radioCustomerAuthenticationStrong: "Strong (Seguro)",
  payCFString: "Texto",
  payCFNumber: "Número",
  payCFCountry2: "País (ISO 2)",
  payCFCountry3: "País (ISO 3)",
  payCFSelect: "Lista",
  payCFRadioVertical: "Radio (vertical)",
  payCFRadioHorizontal: "Radio (horizontal)",
  payCFCheckbox: "Checkbox",
  payCFDate: "Fecha",
  payCFPhone: "Teléfono",
  payerData: "Datos del cliente",
  fullName: "Nombre completo",
  emailAddress: "Dirección de correo",
  cardNumberOptional: "Número de tarjeta (Opcional)",
  mmyy: "MM/AA",
  edtiCard: "Modificar Tarjeta",
  lang: "Idioma",
  description: "Descripción",
  defaultValue: "Valor por defecto",
  type: "Tipo",
  required: "Obligatorio",
  maxLength: "Largo máximo",
  ej250: "ej. 250",
  addField: "Añadir Campo",
  details: "Detalles",
  delete: "Borrar",
  addDetails: "Añadir Detalle",
  sumOtherThan: "Suma distinto de ",
  attachedFiles: "Archivos adjuntos",
  aditionalInfoText1: "Información adicional como facturas, vouchers y otros documentos. Las imagenes indicadas como ",
  aditionalInfoText2: "inline",
  aditionalInfoText3: " son mostradas junto a los datos de la solicitud sin necesidad de descargarlas.",
  noAttachedFiles: "No hay archivos adjuntos",
  inline: "Inline",
  addFile: "Añadir Archivo",
  goToList: "Ir al listado",
  errorVerifyFields: "Verifique los campos con errores",
  errorSumIncorrect: "La suma de los detalles es incorrecta",
  savedRequest: "¡Solicitud guardada!",
  errorCouldNotSave: "No se pudo guardar la solicitud",
  ruleSelectCompany: "Selecciona un comercio",
  ruleRequiredField: "Este campo es necesario",
  ruleDateHigher: "La fecha debe ser superior al día de hoy",
  ruleMinValue1: "El valor mínimo es 1",
  ruleMinValue0: "El valor debe ser mayor a 0",
  ruleInsertVaule: "Ingrese un valor",
  ruleInvalidValue: "El número es inválido o no soportado.",
  ruleInvalidValue2: "Valor inválido",
  advancedOptions: "Opciones Avanzadas",
  urlNotifyLabel: "Url de notificación del pago (Opcional)",
  urlNotifyKoLabel: "Url de notificación del vencimiento (Opcional)",
  urlNotifyTooltip1: "URL que recibirá una petición POST cuando el usuario pague. ",
  urlNotifyTooltip2: "El atributo paymentID del cuerpo JSON indicará la solicitud. ",
  urlNotifyTooltip3: "Para mayor información contactar al ",
  urlNotifyTooltip4: "Servicio Técnico.",
  urlNotifyTooltip5: "URL que recibirá una petición POST cuando el link de pago expire. ",

  // BetterHeaderFilter.vue
  selectAll: "Seleccionar todo",

  // ColorPicker.vue
  primaryColor: "Color Primario",
  ruleHtmlFormat: "El formato debe ser HTML hexadecimal (ej. #FFFFFF).",

  // CompanyEdit.vue
  andoidLogo: "Logos en PAYTEF Android",
  mainViewLogo: "Logo pantalla principal",
  secondaryViewLogo: "Logo secundario de PAYTEF Android",
  imgPngDescription: "Imagen PNG con fondo transparente. Tamaño máximo 530x210, de menos de 5MB.",
  remove: "Quitar",
  logoInReceipt: "Logo en el recibo",
  lagoReceipts: "Logo de recibos...",
  receiptLogoText: "Solo blanco y negro en formato PNG, ancho máximo 400 pixeles.",
  errorLoadingData: "Error cargando datos.",
  errorUploadingFile: "Error subiendo archivo, intente de nuevo.",

  // EmailPreviewDialog.vue
  emailContent: "Contenido del e-mail",

  // LinkRef.vue
  emptyFile: "Archivo vacío.",
  errorAccessingFile: "Error accediendo al archivo, no encontrado.",

  // TxnEditDialog.vue
  cancelPreauthorization: "Cancelar preautorización",
  closePreauthorization: "Cerrar preautorización",
  newCollectOnCard: "Nuevo cobro sobre tarjeta",
  newCardCollect: "Nuevo cobro sobre tarjeta",
  newCardCollectText1:
    "Esta acción anulará la preautorización y liberará los fondos reservados que volverán a la tarjeta original. Verifique los datos a continuación.",
  newCardCollectText2:
    "Esta acción confirmará la transacción y realizará el cobro efectivo de los fondos preautorizados. Verifique los datos a continuación.",
  newCardCollectText3:
    "Se devolverá el importe indicado a la tarjeta de esta transacción. Verifique los datos a continuación.",
  newCardCollectText4:
    "Se cobrará un nuevo importe sobre la tarjeta de la transacción original. Verifique los datos a continuación.",
  originialTransaction: "Transacción original",
  originaAmount: "Importe original",
  newTransactionDataTilte: "Datos de la nueva transacción",
  transactionReferenceId: "Referencia / identificador de transacción",
  refundAmount: "Importe a devolver",
  collectAmount: "Importe a cobrar",
  warning: "Advertencia",
  warningAmountLargerThan: "El importe supera el de la transacción original.",
  adicinalComments: "Comentarios adicionales (motivo de la transacción, datos adicionales, etc)",
  toConfirmOperation1: "Para confirmar la operación escriba",
  toConfirmOperation2: "a continuación y presione",
  accept: "Aceptar",
  back: "Volver",
  ruleMAx500: "Longitud máxima: 500",
  errorCheckForm: "Por favor verifique el formulario, faltan datos.",
  alertEditedTransaction: "¡Transacción modificada con éxito!",
  errorCouldNotEditTransaction: "No se pudo modificar la transacción",
  write: "Escriba",
  refunds: "Devoluciones",
  history: "Historial",

  // TxnInfoDialog.vue
  originalId: "Transacción",
  user: "Usuario",
  comment: "Comentario",
  newCollect: "Nuevo cobro",
  closePreauth: "Cerrar Preaut.",
  cancelPreauth: "Cancelar Preaut.",
  previousOperation: "Operación Anterior",
  goToOperation: "Volver a Operación",
  forceSale: "Venta (Forzada)",
  forceRefund: "Devolución (Forzada)",
  forceSaleTitle: "Venta. Forzar Operación",
  forceRefundTitle: "Devolución. Forzar Operación ",
  forceText: "¿Está seguro de que desea ejecutar la operación?",
  forceWarning: "Esta acción no podrá deshacerse.",
  closeCancelation: "Cierre/Cancelación",

  // TxnReceiptDialog.vue
  loadingReceipt: "Cargando el recibo...",
  couldNotLoadFirm: "No se puede cargar la firma",
  transactionNoReceipt: "Esta transacción no tiene recibo o se produjo un error.",
  loadAgain: "Cargar nuevamente",
  receipt: "Recibo",

  // Upload.vue
  maxSize: "Tamaño máximo",
  fileUploaded: "Archivo subido.",
  fileToBig: "El archivo es demasiado grande. Tamaño máximo",
  cancelled2: "Cancelado.",
  couldNotUploadFile: "No se pudo subir el archivo.",
  invalidUser: "Usuario Invalido.",
  search2: "Buscar",

  //UserEditDialog.vue
  editUser: "Editar Usuario",
  newUser: "Nuevo Usuario",
  sendResetPass: "Enviar reinicio de contraseña",
  assignPass: "Asignar Contraseña",
  newPass: "Nueva Contraseña",
  disabledAccountTxt1: "Esta cuenta esta deshabilitada, el usuario no podrá acceder al sistema, ni ver sus comercios.",
  disabledAccountTxt2: "Contáctese con PAYTEF para habilitarla.",
  accountRolPerCompany: "Permisos de la cuenta por comercio",
  adminInterfaceLbl: "Interfaces de administración",
  consultStadisticsLbl: "Consultar estadísticas",
  consultConnTermLbl: "Consultar conexiones y terminales",
  seeClientApi: "Ver API de clientes",
  consultTransactions: "Consultar transacciones",
  editTransactions: "Modificar transacciones",
  allowedBranches: "Oficinas permitidas",
  addCompanyToAddRole: "Agrega un comercio para asignarle permisos a este usuario.",
  assignRoleBeforeSave: "Por favor, asígnale permisos al usuario antes de guardarlo.",
  blockAccess: "Bloquear Acceso (deshabilitar cuenta)",
  specialPermissions: "Permisos especiales",
  enableEditing: "Habilitar edición",
  specialPermissionsWarning:
    "Estos permisos son potencialmente peligrosos, solo asignar estos permisos a usuarios que los necesiten realmente, no asignar estos permisos de forma masiva",
  alertUserSavedRefresh: "¡Usuario Guardado con éxito! Refrescando lista.",
  alertUserSavedSendedPasswordEmail: "¡Usuario Guardado con éxito! Email de contraseña enviado.",
  errorCouldNotSaveUser: "No se pudo guardar el usuario",
  noAvailableCompanies: "No hay comercios disponibles",
  alertInvalidAddress: "Dirección de correo inválida.",
  resetEmailSended: "Se envio el correo de reseteo de contraseña",
  noPermissions: "Sin permisos",

  // UserAuditDialog.vue
  accessLogs: "Registros de acceso",
  logsLimit: "Límite de registros",
  userWithoutAccessLog: "Este usuario no tiene accesos registrados.",
  logSearchFrom1: "La busqueda de",
  logSearchFrom2: "no produjo resultados.",
  errorUserList: "No se pudo obtener la lista de usuarios",
  accessUtc: "Acceso (UTC)",
  uid: "UID",

  //euroshellCertificate.vue
  newCertificate: "Nuevo Certificado",
  newEuroshellCertificate: "Nuevo Certificado Euroshell",
  download: "Descargar",
  noCertificatesAvailable: "No existen certificados generados en las fechas seleccionadas",
  euroshellCertificates: "Certificados Euroshell",
  dateOfIssue: "Fecha de emisión:",
  previousTransaction: "Operación Anterior",

  // management.vue
  debugTerminals: "Terminales DEBUG (DISA)",
  noTerminalsAvailable: "No se encontraron terminales de DEBUG.",
  newTerminal: "Nueva Terminal",
  editTerminal: "Editar Terminal",
  mac: "MAC",
  app: "Aplicación",
  administration: "Administración",
  deleteDebugTerminalText: "Esta seguro que desea eliminar la terminal, esta acción no podrá deshacerse.",
  deleteTerminal: "Eliminar Terminal",
  delete1: "Eliminar",

  // Payment loading leave-confirmation
  confirmLeaveTitle: "¿Seguro que quieres salir?",
  confirmLeaveText: "La solicitud de pago se está guardando. Si sales ahora, podrías interrumpir la operación.",
  confirmLeaveBtnStay: "Quedarme",
  confirmLeaveBtnLeave: "Salir de todas formas"
};

export default lang;
